import { Button, Prompt } from '@components'
import { MobileEmbedMessages } from '@constants'
import { useBusinessContext, useMobileEmbed } from '@context'
import { deleteBusiness } from '@query'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FaTrashAlt } from 'react-icons/fa'
import { useMutation } from '@tanstack/react-query'
import styled from 'styled-components'
import { SettingsDataCard } from '@pages/SettingsPage/components/SettingsDataCard'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'

export const BusinessDangerZoneSettings: React.FC = () => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const { isEmbedded, postMessage } = useMobileEmbed()
  const [showDelete, setShowDelete] = useState(false)

  const deleteMutation = useMutation({
    mutationFn: () => deleteBusiness({ slug }),
    ...{
      onSuccess: () => {
        if (isEmbedded) {
          postMessage(MobileEmbedMessages.BUSINESS_DELETED_COMPLETE)
          return
        }

        window.location.href = '/'
      }
    }
  })

  return (
    <SettingsSubPageLayout title={t('settings.sections.businessDeletion')}>
      <SettingsDataCard
        icon={<FaTrashAlt />}
        title={t('settings.deleteBusiness')}
        body={
          <DangerActions>
            <Button
              onClick={() => setShowDelete(true)}
              isSecondary
              intent="danger"
              icon={<FaTrashAlt />}
              showSpinner={deleteMutation.isPending}
            >
              {t('settings.deleteBusiness')}
            </Button>
          </DangerActions>
        }
      />

      <Prompt
        title={t('settings.deletePromptTitle')}
        description={t('settings.deletePromptContent')}
        isVisible={showDelete}
        onClose={() => setShowDelete(false)}
        buttons={[
          {
            text: t('general.cancel'),
            action: () => setShowDelete(false)
          },
          {
            text: t('settings.deleteBusiness'),
            intent: 'danger',
            action: () => deleteMutation.mutate()
          }
        ]}
      />
    </SettingsSubPageLayout>
  )
}

const DangerActions = styled.div`
  display: flex;
  justify-content: flex-end;
`
